// src/components/Player.jsx



import React, {

  useEffect,

  useRef,

  useState,

} from 'react';



import {

  Link,

  useLocation,

  useParams,

} from 'react-router-dom';



import {

  useContinueWatching,

} from '../context/ContinueWatchingContext';



import {

  getMovieQuickInfo,

  getTvQuickInfo,

} from '../services/tmdbService';



import '../styles/Player.css';





/* ============================================================

   MOVIE PLAYER SOURCES

   ============================================================ */



const MOVIE_SOURCES = [

  {

    name: 'Server 1',

    provider: 'VidNest',



    url: (id) =>

      `https://vidnest.fun/movie/${encodeURIComponent(id)}`,

  },



  {

    name: 'Server 2',

    provider: 'VidLink',



    url: (id) =>

      `https://vidlink.pro/movie/${encodeURIComponent(

        id

      )}?primaryColor=7c3aed&secondaryColor=a2a2a2&iconColor=eefdec&poster=true&title=true&nextbutton=false&player=jw&autoplay=false`,

  },



  {

    name: 'Server 3',

    provider: 'VidSrc.cc',



    url: (id) =>

      `https://vidsrc.cc/v2/embed/movie/${encodeURIComponent(

        id

      )}?autoPlay=true`,

  },



  {

    name: 'Server 4',

    provider: 'VidSrc RU',



    url: (id) =>

      `https://vidsrc-embed.ru/embed/movie/${encodeURIComponent(

        id

      )}?autoPlay=true`,

  },



  {

    name: 'Server 5',

    provider: 'MultiEmbed',



    url: (id) =>

      `https://multiembed.mov/?video_id=${encodeURIComponent(

        id

      )}&tmdb=1&autoPlay=true`,

  },



  {

    name: 'Server 6',

    provider: 'VidSrc.sh',



    url: (id) =>

      `https://vidsrc.sh/embed/movie/${encodeURIComponent(

        id

      )}`,

  },



  {

    name: 'Server 7',

    provider: 'Embed API Stream',



    url: (id) =>

      `https://watch.embed-api.stream/embed/movie/${encodeURIComponent(

        id

      )}`,

  },
  {
    name: 'Server 8',
    provider: 'ezvidapi',
    url: (id) => `https://ezvidapi.com/embed/movie/${encodeURIComponent(id)}`,
  },
  {
    name: 'Server 9',
    provider: 'EmbedWave',
    url: (id) => `https://embedwave.cc/embed/movie/${encodeURIComponent(id)}`,
  },
  {
    name: 'Server 10',
    provider: 'ScreenScape',
    url: (id) => `https://nxsha.screenscape.me/embed?tmdb=${encodeURIComponent(id)}&type=movie`,
  },
];





/* ============================================================

   TV PLAYER SOURCES

   ============================================================ */



const TV_SOURCES = [

  {

    name: 'Server 1',

    provider: 'VidNest',



    url: (id, season, episode) =>

      `https://vidnest.fun/tv/${encodeURIComponent(

        id

      )}/${encodeURIComponent(

        season

      )}/${encodeURIComponent(

        episode

      )}`,

  },



  {

    name: 'Server 2',

    provider: 'VidLink',



    url: (id, season, episode) =>

      `https://vidlink.pro/tv/${encodeURIComponent(

        id

      )}/${encodeURIComponent(

        season

      )}/${encodeURIComponent(

        episode

      )}?primaryColor=7c3aed&secondaryColor=a2a2a2&iconColor=eefdec&poster=true&title=true&nextbutton=false&player=jw&autoplay=false`,

  },



  {

    name: 'Server 3',

    provider: 'VidSrc.cc',



    url: (id, season, episode) =>

      `https://vidsrc.cc/v2/embed/tv/${encodeURIComponent(

        id

      )}/${encodeURIComponent(

        season

      )}/${encodeURIComponent(

        episode

      )}`,

  },



  {

    name: 'Server 4',

    provider: 'VidSrc RU',



    url: (id, season, episode) =>

      `https://vidsrc-embed.ru/embed/tv/${encodeURIComponent(

        id

      )}/${encodeURIComponent(

        season

      )}/${encodeURIComponent(

        episode

      )}`,

  },



  {

    name: 'Server 5',

    provider: 'MultiEmbed',



    url: (id, season, episode) =>

      `https://multiembed.mov/?video_id=${encodeURIComponent(

        id

      )}&tmdb=1&s=${encodeURIComponent(

        season

      )}&e=${encodeURIComponent(

        episode

      )}`,

  },



  {

    name: 'Server 6',

    provider: 'VidSrc.sh',



    url: (id, season, episode) =>

      `https://vidsrc.sh/embed/tv/${encodeURIComponent(

        id

      )}/${encodeURIComponent(

        season

      )}/${encodeURIComponent(

        episode

      )}`,

  },



  {

    name: 'Server 7',

    provider: 'Embed API Stream',



    url: (id, season, episode) =>

      `https://watch.embed-api.stream/embed/tv/${encodeURIComponent(

        id

      )}/${encodeURIComponent(

        season

      )}/${encodeURIComponent(

        episode

      )}`,

  },
  {
    name: 'Server 8',
    provider: 'ezvidapi',
    url: (id, season, episode) => `https://ezvidapi.com/embed/tv/${encodeURIComponent(id)}/${encodeURIComponent(season)}/${encodeURIComponent(episode)}`,
  },
  {
    name: 'Server 9',
    provider: 'EmbedWave',
    url: (id, season, episode) => `https://embedwave.cc/embed/tv/${encodeURIComponent(id)}/${encodeURIComponent(season)}/${encodeURIComponent(episode)}`,
  },
  {
    name: 'Server 10',
    provider: 'ScreenScape',
    url: (id, season, episode) => `https://nxsha.screenscape.me/embed?tmdb=${encodeURIComponent(id)}&type=tv&s=${encodeURIComponent(season)}&e=${encodeURIComponent(episode)}`,
  },
];





/* ============================================================

   PLAYER COMPONENT

   ============================================================ */



const Player = () => {

  const { id: routeId } = useParams();



  const { search } = useLocation();



  const playerRef = useRef(null);





  /* ==========================================================

     URL PARAMETERS

     ========================================================== */



  const queryParams =

    new URLSearchParams(search);



  const id =

    queryParams.get('id') ||

    routeId ||

    '';



  const season =

    queryParams.get('s') ||

    '';



  const episode =

    queryParams.get('e') ||

    '';





  /* ==========================================================

     CONTINUE WATCHING

     ========================================================== */



  const {

    addToContinueWatching,

  } = useContinueWatching();





  /* ==========================================================

     STATE

     ========================================================== */



  const [showAd, setShowAd] =

    useState(true);



  const [sourceIndex, setSourceIndex] =

    useState(0);



  const [playerKey, setPlayerKey] =

    useState(0);



  const [loading, setLoading] =

    useState(true);



  const [isFullscreen, setIsFullscreen] =

    useState(false);



  const [failedServers, setFailedServers] =

    useState([]);





  /* ==========================================================

     MOVIE / TV

     ========================================================== */



  const isTV =

    Boolean(season && episode);



  const sources = isTV

    ? TV_SOURCES

    : MOVIE_SOURCES;



  const currentSource =

    sources[sourceIndex];





  /* ==========================================================

     FULLSCREEN DETECTION

     ========================================================== */



  useEffect(() => {

    const handleFullscreenChange =

      () => {

        setIsFullscreen(

          document.fullscreenElement ===

            playerRef.current

        );

      };



    document.addEventListener(

      'fullscreenchange',

      handleFullscreenChange

    );



    return () => {

      document.removeEventListener(

        'fullscreenchange',

        handleFullscreenChange

      );

    };

  }, []);





  /* ==========================================================

     FULLSCREEN FUNCTION

     ========================================================== */



  const handleFullscreen =

    async () => {

      if (!playerRef.current) {

        return;

      }



      try {

        if (document.fullscreenElement) {

          await document.exitFullscreen();

          return;

        }



        if (

          playerRef.current

            .requestFullscreen

        ) {

          await playerRef.current

            .requestFullscreen();



          return;

        }



        if (

          playerRef.current

            .webkitRequestFullscreen

        ) {

          playerRef.current

            .webkitRequestFullscreen();



          return;

        }



        if (

          playerRef.current

            .mozRequestFullScreen

        ) {

          playerRef.current

            .mozRequestFullScreen();



          return;

        }



        if (

          playerRef.current

            .msRequestFullscreen

        ) {

          playerRef.current

            .msRequestFullscreen();

        }



      } catch (error) {

        console.error(

          'Fullscreen error:',

          error

        );

      }

    };





  /* ==========================================================

     CONTINUE WATCHING

     ========================================================== */



  useEffect(() => {

    const trackWatch =

      async () => {

        if (!id) {

          return;

        }



        try {

          let item;



          if (isTV) {

            item =

              await getTvQuickInfo(id);



            if (item) {

              item.season =

                Number(season);



              item.episode =

                Number(episode);

            }



          } else {

            item =

              await getMovieQuickInfo(id);

          }



          if (item) {

            addToContinueWatching(

              item

            );

          }



        } catch (error) {

          console.error(

            'Failed to track watch:',

            error

          );

        }

      };



    trackWatch();



  }, [

    id,

    season,

    episode,

    isTV,

    addToContinueWatching,

  ]);





  /* ==========================================================

     RESET PLAYER WHEN CONTENT CHANGES

     ========================================================== */



  useEffect(() => {

    setSourceIndex(0);



    setPlayerKey(

      (value) => value + 1

    );



    setLoading(true);



    setFailedServers([]);



  }, [

    id,

    season,

    episode,

  ]);





  /* ==========================================================

     AUTO FALLBACK

     ========================================================== */



  const tryNextServer = () => {

    const updatedFailedServers =

      failedServers.includes(sourceIndex)

        ? failedServers

        : [

            ...failedServers,

            sourceIndex,

          ];



    setFailedServers(

      updatedFailedServers

    );





    /*

     * Cari server berikutnya

     * yang belum dicoba.

     */



    let nextIndex =

      sources.findIndex(

        (_, index) =>

          index > sourceIndex &&

          !updatedFailedServers.includes(

            index

          )

      );





    /*

     * Jika tidak ada server setelah

     * server sekarang, cari dari awal.

     */



    if (nextIndex === -1) {

      nextIndex =

        sources.findIndex(

          (_, index) =>

            !updatedFailedServers.includes(

              index

            )

        );

    }





    /*

     * Semua server sudah dicoba.

     */



    if (nextIndex === -1) {

      console.warn(

        'All player servers failed.'

      );



      setLoading(false);



      return;

    }





    console.log(

      `Fallback Server ${

        sourceIndex + 1

      } → Server ${

        nextIndex + 1

      }`

    );





    setLoading(true);



    setSourceIndex(

      nextIndex

    );



    setPlayerKey(

      (value) => value + 1

    );

  };





  /* ==========================================================

     PLAYER TIMEOUT

     ========================================================== */



  useEffect(() => {

    if (!loading) {

      return;

    }



    /*

     * Tunggu 20 detik.

     * Jika belum selesai, coba server berikutnya.

     */



    const timeout =

      setTimeout(() => {

        console.warn(

          `Timeout: ${

            currentSource?.provider

          }`

        );



        tryNextServer();



      }, 20000);





    return () => {

      clearTimeout(timeout);

    };



  }, [

    playerKey,

    sourceIndex,

    loading,

  ]);





  /* ==========================================================

     CHANGE SERVER MANUALLY

     ========================================================== */



  const changeServer =

    (index) => {

      if (

        index === sourceIndex

      ) {

        return;

      }



      setLoading(true);



      setSourceIndex(index);



      setPlayerKey(

        (value) => value + 1

      );

    };





  /* ==========================================================

     EMBED URL

     ========================================================== */



  const embedUrl =

    isTV

      ? currentSource.url(

          id,

          season,

          episode

        )

      : currentSource.url(id);





  /* ==========================================================

     DETAILS URL

     ========================================================== */



  const detailsUrl =

    isTV

      ? `/tv/${id}`

      : `/movie/${id}`;





  /* ==========================================================

     INVALID ID

     ========================================================== */



  if (!id) {

    return (

      <div className="player player-error">



        <div className="player-error-content">



          <h2>

            Unable to load player

          </h2>



          <p>

            Movie or TV show ID is missing.

          </p>



          <Link to="/">

            Return Home

          </Link>



        </div>



      </div>

    );

  }





  /* ==========================================================

     RENDER

     ========================================================== */



  return (

    <div

      ref={playerRef}



      className={

        isFullscreen

          ? 'player player-is-fullscreen'

          : 'player'

      }

    >



      {/* ======================================================

          VIDEO PLAYER

          ====================================================== */}



      <div className="player-frame">



        {loading && (

          <div className="player-loading">



            <div className="player-spinner"></div>



            <p>

              Loading{' '}

              {currentSource.provider}

              ...

            </p>



            <small>

              Trying Server{' '}

              {sourceIndex + 1}

              {' / '}

              {sources.length}

            </small>



          </div>

        )}





        <iframe

          key={playerKey}



          title={

            `Defilms Player - ${

              currentSource.provider

            }`

          }



          src={embedUrl}



          frameBorder="0"



          scrolling="no"



          allow="

            autoplay;

            fullscreen;

            encrypted-media;

            picture-in-picture

          "



          allowFullScreen



          onLoad={() => {

            setLoading(false);



            console.log(

              `Loaded: ${

                currentSource.provider

              }`

            );

          }}



          onError={() => {

            console.warn(

              `Error: ${

                currentSource.provider

              }`

            );



            tryNextServer();

          }}

        />



      </div>





      {/* ======================================================

          SERVER SELECTOR

          ====================================================== */}



      {!isFullscreen && (

        <div className="player-server-bar">



          <div className="player-server-label">



            <span className="server-icon">

              <i className="fa-solid fa-server"></i>

            </span>



            <span>

              Server

            </span>



          </div>





          <div className="player-server-list">



            {sources.map(

              (source, index) => (

                <button

                  key={

                    source.provider

                  }



                  type="button"



                  className={

                    sourceIndex === index

                      ? 'player-server active'

                      : 'player-server'

                  }



                  onClick={() =>

                    changeServer(

                      index

                    )

                  }



                  title={

                    failedServers.includes(

                      index

                    )

                      ? `${source.provider} - failed`

                      : source.provider

                  }

                >



                  {source.name}



                </button>

              )

            )}



          </div>





          <div className="player-current-server">

            {currentSource.provider}

          </div>



        </div>

      )}





      {/* ======================================================

          TOP CONTROLS

          ====================================================== */}



      <div className="overlay">



        <button

          type="button"



          className="player-fullscreen-button"



          onClick={

            handleFullscreen

          }



          aria-label={

            isFullscreen

              ? 'Exit Fullscreen'

              : 'Fullscreen'

          }



          title={

            isFullscreen

              ? 'Exit Fullscreen'

              : 'Fullscreen'

          }

        >



          <i

            className={

              isFullscreen

                ? 'fa-solid fa-compress'

                : 'fa-solid fa-expand'

            }

          ></i>



        </button>





        <Link

          to="/"



          aria-label="Home"



          title="Home"

        >



          <i className="fa-solid fa-home"></i>



        </Link>





        <Link

          to={detailsUrl}



          aria-label="Close Player"



          title="Close Player"

        >



          <i className="fa-solid fa-xmark"></i>



        </Link>



      </div>





      {/* ======================================================

          SUPPORT US

          ====================================================== */}



      {showAd &&

        !isFullscreen && (



          <div className="ad">



            <button

              type="button"



              className="ad-close"



              onClick={() =>

                setShowAd(false)

              }



              aria-label="Close Support Us"



              title="Close"

            >



              <i className="fa-solid fa-xmark"></i>



            </button>





            <h1>

              Support Us

            </h1>





            <p>

              Your donations help us

              maintain and improve our

              services, ensuring we can

              continue offering you this

              premium, ad-free entertainment

              every day and forever.{' '}



              <a

                href="https://defilms.online/#donate"



                target="_blank"



                rel="noreferrer noopener"

              >

                Support us by making a

                donation.

              </a>



            </p>



          </div>

        )}



    </div>

  );

};





export default Player;